import * as React from 'react';
import * as styled from './styled';
import {useContext} from '../../../../hooks/useContext';
import {
  DragDropContext,
  Draggable,
  Droppable,
  DropResult,
} from 'react-beautiful-dnd';

/**
 * The accordance content render.
 * @return {React.ReactElement}
 * @constructor
 */
export default function Accordance(): React.ReactElement {
  const {block} = useContext();

  // @ts-ignore
  const pairs: [string, string][] = block.pairs || [];

  /**
   * Render droppable.
   * @param {string} droppableId
   * @param {string[]} words
   * @return {JSX.Element}
   */
  function renderDroppable(droppableId: string, words: string[]): JSX.Element {
    return (
      <Droppable droppableId={droppableId}>
        {(provided) => (
          <styled.Group ref={provided.innerRef} {...provided.droppableProps}>
            {words.map((word, index) => (
              <Draggable draggableId={word} index={index}>
                {(provided) => (
                  <styled.WordWrapper
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}>
                    <styled.WordInner>
                      {word}
                    </styled.WordInner>
                  </styled.WordWrapper>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </styled.Group>
        )}
      </Droppable>
    );
  }

  /**
   * The drag end handle event.
   * @param {DropResult} result
   */
  function handleDragEnd(result: DropResult): void {

  }

  return (
    <DragDropContext onDragEnd={handleDragEnd}>
      <styled.Wrapper>
        {renderDroppable('left', ['Путин', 'Вода', 'Балалайка'])}
        {renderDroppable('right', ['Америка', 'Калифрония', 'Лондон'])}
      </styled.Wrapper>
    </DragDropContext>
  );
}
